import { Button, Divider, Form, Input, Select, Switch, Tabs, DatePicker } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { ERegExp } from '../../enums/ERegExp';
import EUsersTypes from '../../enums/EUsersTypes';
import { displayMessage } from '../../helpers/messages';
import api from '../../services/api';
import { MaskedInput } from 'antd-mask-input';
import { cpfMask, cpfUnmask, phoneMask, phoneUnmask } from '../../helpers/iMask';
import dayjs from 'dayjs';

const DATE_FORMAT = 'DD/MM/YYYY';



const { Option } = Select
var userTypeList = Object.values(EUsersTypes)
    .filter(userType =>[EUsersTypes.EMPLOYEE.code, EUsersTypes.CLIENT_ADMIN.code].includes(userType.code))
    .map(userType => {
        return (
            { value: userType.code, label: userType.title }
        )
    })

export default function DetailUser() {
    const [form] = Form.useForm()
    const { idUser } = useParams()
    const [readOnly, setReadOnly] = useState(true)
    const [user, setUser] = useState(null)
    // const [clientsList, setClientsList] = useState(null)
    let hasChanged = false

    const {
        setShowLoading,
        mobile_mode,
        windowHeight,
        loadBadges,
        loggedUser
    } = useContext(GeneralContext)

    useEffect(() => {
        loadUserInfo(idUser)
    }, [])

    useEffect(() => {
        if (readOnly) {
            cpfMask('cpf-number')
            phoneMask('whatsapp-number')
        }
    }, [user])

    const loadUserInfo = async (id) => {
        try {
            let tempUser = await api.user.get(id)
            console.log(tempUser.data)
            // let tempClientList = await api.client.list()
            // setClientsList(tempClientList.data)
            
            // Formatar a data de expiração para o DatePicker
            const formData = {
                ...tempUser.data,
                plan_expired: tempUser.data.plan_expired ? dayjs(tempUser.data.plan_expired) : null
            }
            
            form.setFieldsValue(formData)
            setUser(tempUser.data)
        } catch (error) {
            alert(displayMessage('INVALID_USER'), 'warning')
        }
    }
    const onFinishEdit = async (values) => {
        if (readOnly) {
            setReadOnly(current => !current)
            return
        }

        setShowLoading(true)
        try {
            if (hasChanged) {
                let body = {
                    ...values,
                    id: user.id,
                    whatsapp: values.whatsapp ? phoneUnmask(values.whatsapp) : null,
                    cpf: values.cpf ? cpfUnmask(values.cpf) : null,
                    need_appointment: values.need_appointment,
                    free_appointment: values.free_appointment,
                    type: values.user_type,
                    user_type: values.user_type,
                    plan_expired: values?.plan_expired ? values.plan_expired.format('YYYY-MM-DD') : null,
                }
                await api.user.update(body)
                alert(displayMessage('USER_DATA_SAVED_SUCCESS'), 'success', displayMessage('SUCCESS'))
            }
        } finally {
            setReadOnly(current => !current)
            setShowLoading(false)
        }
    }

    const onCloseEdit = () => {
        setReadOnly(true)
        loadUserInfo(idUser)
    }

    const onOpenEdit = () => {
        readOnly ? setReadOnly(false) : form.submit()
    }

    const toggleActiveState = async () => {
        setShowLoading(true)

        try {
            if (!idUser) {
                alert(displayMessage('ERROR_UPDATE_USER_STATUS'), 'error', displayMessage('ERROR'))
                return
            }

            await api.user.changeActive(idUser)
            loadUserInfo(idUser)
        } catch (error) {
            alert(displayMessage('ERROR_UPDATE_USER_STATUS'), 'error', displayMessage('ERROR'))
        } finally {
            setShowLoading(false)
        }
    }

    async function onClickDoneConsulting() {
        setShowLoading(true)
        try {
            if (!idUser) {
                alert(displayMessage('USER_NOT_FOUND'), 'error', displayMessage('ERROR'))
                return
            }

            const { data } = await api.user.changeLastAppointment(idUser)

            form.setFieldsValue(data)
            setUser(data)
            loadBadges()
            loadUserInfo(idUser)
        } catch (error) {
            alert(displayMessage('ERROR_CHANGE_USER_INTEREST'), 'error', displayMessage('ERROR'))
        } finally {
            setShowLoading(false)
        }
    }

    const userIsActive = user?.is_active ? true : false

    return (
        <>
            <div className='font-bold text-lg text-appian-blue text-center' style={{ marginBottom: 10 }}>{displayMessage('DETAIL_USER')}</div>
            <div className='w-full flex-1'>
                <Tabs
                    defaultActiveKey="1"
                    className='h-full'
                    tabBarStyle={{
                        display: 'flex',
                        height: '50px'
                    }}
                    items={[
                        {
                            label: displayMessage('PERSONAL_DATA'),
                            key: '1',
                            children: (
                                <>
                                    <Form
                                        onFinish={onFinishEdit}
                                        layout="vertical"
                                        requiredMark='optional'
                                        form={form}
                                        onValuesChange={() => { hasChanged = true }}
                                    >
                                        <div style={{ maxWidth: '100%', flexDirection: 'column', gap: 10, display: 'flex' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>
                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold' >{displayMessage('FIRST_NAME')}:</span>}
                                                    name="first_name"
                                                    className={`w-full m-[0]`}
                                                    style={{ flex: 1 }}
                                                    rules={[
                                                        { required: true, message: displayMessage('FIRST_NAME_MANDATORY') },
                                                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                        { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                    ]}
                                                >
                                                    <Input type="text" className='text-fit-red-900' disabled={readOnly} />
                                                </Form.Item>

                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold' >{displayMessage('LAST_NAME')}:</span>}
                                                    name="last_name"
                                                    className={`w-full m-[0]`}
                                                    style={{ marginLeft: mobile_mode ? 0 : 5, flex: 1 }}
                                                    rules={[
                                                        { required: true, message: displayMessage('LAST_NAME_MANDATORY') },
                                                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                        { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                    ]}
                                                >
                                                    <Input type="text" className='text-fit-red-900' disabled={readOnly} />
                                                </Form.Item>
                                            </div>

                                            <Form.Item
                                                label={<span className='text-fit-red-900 font-semibold' > {displayMessage('EMAIL')}:</span>}
                                                name="email"
                                                className={`w-full m-0`}
                                                rules={[
                                                    { required: false },
                                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                ]}
                                                style={{ flex: 1 }}

                                            >
                                                <Input type="email" className='text-fit-red-900' disabled={readOnly} />
                                            </Form.Item>
                                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>
                                                <div style={{ display: 'flex', flex: 5, justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>

                                                    <Form.Item
                                                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CPF')}:</span>}
                                                        name="cpf"
                                                        className={`w-full m-0`}
                                                        style={{ flex: 1 }}
                                                    >
                                                        {readOnly ?
                                                            <Input type="text" className='text-fit-red-900' disabled id='cpf-number' />
                                                            :
                                                            <MaskedInput disabled mask='000.000.000-00' />
                                                        }
                                                    </Form.Item>

                                                    <Form.Item
                                                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('WHATSAPP')}:</span>}
                                                        name="whatsapp"
                                                        className={`w-full m-0`}
                                                        rules={[
                                                            { required: false },
                                                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') },
                                                        ]}
                                                        style={{ flex: 1 }}
                                                    >
                                                        {readOnly ?
                                                            <Input type="text" className='text-fit-red-900' disabled id='whatsapp-number' />
                                                            :
                                                            <MaskedInput mask='+00 (00) 00000-0000' />
                                                        }
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('USER_TYPE')}:</span>}
                                                    name="user_type"
                                                    className={`w-full m-0`}
                                                    rules={[{ required: true, message: displayMessage('USER_TYPE_MANDATORY') }]}
                                                    style={{ flex: 1 }}
                                                >
                                                        <Select disabled={readOnly}>
                                                            {userTypeList.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
                                                        </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold'>Validade do Plano:</span>}
                                                    name="plan_expired"
                                                    className={`w-full m-0`}
                                                    style={{ flex: 1 }}
                                                >
                                                    <DatePicker 
                                                        format={DATE_FORMAT}
                                                        placeholder="Sem limite"
                                                        style={{ width: '100%' }}
                                                        disabled={readOnly}
                                                        allowClear
                                                    />
                                                </Form.Item>
                                            </div>
                                            
                                            {user?.plan_expired && (
                                                <div style={{ 
                                                    marginTop: 10, 
                                                    padding: '8px 12px', 
                                                    borderRadius: 6,
                                                    backgroundColor: user?.is_plan_active ? '#f6ffed' : '#fff2f0',
                                                    border: `1px solid ${user?.is_plan_active ? '#b7eb8f' : '#ffccc7'}`
                                                }}>
                                                    <span style={{ 
                                                        color: user?.is_plan_active ? '#52c41a' : '#ff4d4f',
                                                        fontWeight: 500
                                                    }}>
                                                        {user?.is_plan_active 
                                                            ? `✓ Plano ativo${user?.days_until_expiration ? ` (${user.days_until_expiration} dias restantes)` : ''}`
                                                            : '✗ Plano expirado'
                                                        }
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </Form>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flex: 1, flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <Button
                                            style={{ minWidth: 80, marginTop: 15, maxWidth: '30%' }}
                                            type={'primary'}
                                            onClick={() => toggleActiveState()}
                                            danger={!userIsActive}
                                        >
                                            {userIsActive ? displayMessage('IS_ACTIVE') : displayMessage('IS_INACTIVE')}
                                        </Button>

                                        <div style={{ display: 'flex', width: mobile_mode ? '100%' : 300, justifyContent: mobile_mode ? 'space-between' : 'flex-end', flexDirection: 'row', marginTop: mobile_mode ? 20 : 0 }}>
                                            <Button
                                                style={{ minWidth: 80, marginTop: 15, marginLeft: mobile_mode ? 0 : 10 }}
                                                type={'primary'}
                                                onClick={onOpenEdit}
                                            >
                                                {readOnly ? displayMessage('EDIT') : displayMessage('SAVE_EDIT')}
                                            </Button>
                                            {
                                                !readOnly ?
                                                    <Button
                                                        style={{ minWidth: 80, marginTop: 15, marginLeft: mobile_mode ? 0 : 10 }}
                                                        type={'primary'}
                                                        onClick={onCloseEdit}
                                                        danger

                                                    >
                                                        {displayMessage('CLOSE')}
                                                    </Button>
                                                    :
                                                    <div />
                                            }
                                        </div>
                                    </div>                          
                                </>
                            )
                        },
                        // {
                        //     label: displayMessage('DIET_LIST'),
                        //     key: '2',
                        //     style: { height: '100%', },
                        //     children: (
                        //         <AttachmentsListDiet />
                        //     )
                        // },
                        // {
                        //     label: displayMessage('TRAINING_LIST'),
                        //     key: '3',
                        //     style: { height: '100%', },
                        //     children: (
                        //         <AttachmentsListTraining />
                        //     )
                        // }
                    ]}
                />
            </div>
        </>
    )
}